<template>
  <div>
    <PageHeader :title="update ? 'ویرایش پست' : 'اضافه کردن پست'" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="card mb-3 p-3">
          <div class="section-title"><span style="color: rgb(254, 94, 97)">*</span> قالب</div>

          <b-form-group>
            <b-form-radio-group v-model="model.template" :options="articleCategories" value-field="key" text-field="value" @input="onChooseTemplate"></b-form-radio-group>
          </b-form-group>

          <label v-if="model.template === undefined && submit" :class="{ template_error: model.template === undefined && submit }">وارد کردن این فیلد الزامی است.</label>
        </div>

        <div class="card p-3 mt-3 my-auto d-flex flex-row justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <b-form-checkbox v-model="model.isEnable" class="pt-2">
              <div class="mx-1">عدم نمایش پست</div>
            </b-form-checkbox>

            <b-form-checkbox v-model="model.isSuperior" class="pt-2">
              <div class="mx-1">پست برتر</div>
            </b-form-checkbox>
          </div>

          <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
            <i class="far fa-times-circle"></i>

            <span class="ms-2">حذف پست</span>
          </b-button>
        </div>

        <div class="inner__style">
          <div
            v-if="!model.image"
            :class="['upload_icon', { empty_upload_icon: submit && !model.image }]"
            @click="(event) => (this.model.image.length ? event.preventDefault() : $refs.fileInput.click())"
          >
            <div>
              <i :class="['fas fa-cloud-upload-alt icon-size', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>

              <div class="upload_text">آپلود بنر پست ها</div>
            </div>
            <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
          </div>

          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-photo">
                <div class="remove-icon" @click="model.image = ''">
                  <i class="fa fa-times"></i>
                </div>

                <img class="previewImage" :src="model.image" />
              </div>
            </div>
          </div>

          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین" placeholder="متن جایگزین" />
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card" style="overflow-y: unset">
          <Section title="اطلاعات پست">
            <div class="my-3">
              <BaseText required :showError="submit && !model.title" errortext="فیلد عنوان الزامی است." :maxlength="2000" v-model="model.title" title="عنوان" placeholder="عنوان" />
            </div>

            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.writer" @input="model.writer = $event" title="پدیدآورنده" placeholder="پدیدآورنده" />
            </div>

            <div class="my-3 time_to_read">
              <BaseText :maxlength="2000" v-model="model.timeToRead" title="زمان مطالعه / مشاهده" placeholder="زمان مطالعه / مشاهده" inputType="number" />
            </div>

            <div class="my-3">
              <TextAreaInput v-model="model.shortDescription" title="توضیح مختصر" rows="2" :maxlength="20000" placeholder="توضیح مختصر" />
            </div>

            <div>
              <EditorInput :value="model.description" @input="model.description = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>

            <Tags title="موضوع" :value="model.subject" class="mt-4" classes="tags" @input="model.subject = $event" placeholder="موضوع" />

            <DateTimeOffset v-model="model.date" @input="setDate($event)" class="mt-4" :hasDefaultDate="false" title="تاریخ" placeholder="تاریخ" :key="model.date" />

            <div :class="['upload_video my-4', { 'justify-content-start': model.url && !videoLoading }]" @click="onOpenVideoModal">
              <div v-if="model.url || videoLoading">
                <div :class="{ audio_border: checkFile !== 'video' && !['mp4', 'mpeg', 'mkv', 'flv', 'webm', 'gif', 'wmv', 'avi'].includes(this.model.urlType) && !videoLoading }">
                  <i v-if="videoLoading" class="fas fa-spin fa-spinner icon-size"></i>

                  <div v-else style="position: relative">
                    <div v-if="checkFile === 'video' || ['mp4', 'mpeg', 'mkv', 'flv', 'webm', 'gif', 'wmv', 'avi'].includes(this.model.urlType)">
                      <video :src="model.url" controls class="video" />

                      <i class="fas fa-times-circle close_icon" @click="model.url = ''"></i>
                    </div>
                    <div v-else class="audio">
                      <img src="../../../assets/images/dadbanan/music.svg" />

                      <i class="fas fa-times-circle close_icon" @click="model.url = ''"></i>
                    </div>
                  </div>

                  <div v-if="videoLoading" class="pro">
                    <div class="progress-b">
                      <b-progress :value="percentCompleted ? percentCompleted : 0" :max="100" animated height="10" />
                    </div>

                    <div class="percent">{{ percentCompleted ? percentCompleted : 0 }}%</div>
                  </div>
                </div>
              </div>

              <div v-else>
                <i class="fas fa-cloud-upload-alt icon-size"></i>

                <div class="upload_text">آپلود ویدئو یا پادکست</div>
              </div>
            </div>
            <!-- 
            <div v-if="!model.image" class="upload_video d-flex justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
              <div>
                <i class="fas fa-cloud-upload-alt icon-size"></i>

                <div class="upload_text">آپلود عکس یا فایل</div>
              </div>
            </div> -->

            <UploadBox
              :cloud="true"
              accept="image/*,.xlsx,.pdf,.docx,.pptx"
              @fileBoxData="uploadedFile($event)"
              :imageHeight="220"
              :componentData="url"
              :imageFile="model.secondUrl"
              :fileType="model.secondUrlType"
              :fileTitle="model.secondUrlName"
              :filesLength="1"
              placeholder="آپلود عکس یا فایل"
            />
          </Section>

          <Section title="لینک">
            <div>
              <EditorInput :value="model.link" @input="model.link = $event" title="لینک" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>

        <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
            </div>

            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>

            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>

    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/posts')">انصراف</b-button>

      <b-button variant="primary ms-2 px-5" @click="addPost">ثبت</b-button>
    </div>

    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>

        <div class="error-title text-center">آیا از حذف پست اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>

            <b-button class="ms-2 col-6" variant="primary" block @click="deleteArticle">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <Toast :title="message" :error="error" :showToast="showToast" />

    <b-modal id="videoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeUpload">
      <template #modal-title>بارگذاری ویدئو</template>

      <div class="p-3">
        <VideoUpload
          :percent="percentCompleted"
          accept="video/*,audio/*"
          uploadButtonLabel="تایید"
          :loading="cropperLoading"
          @videoSourceChanged="uploadVideo($event)"
          @onFileSelected="onUploadFile"
          @close="closeUpload"
        />
      </div>
    </b-modal>
  </div>
</template>
<script>
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import fileMannager from '../../../services/file'
import dadbanArticlesProvider from '../../../services/dadban/article'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import Tags from '../../common/form/formModules/Tags.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import VideoUpload from '../../common/form/VideoUpload.vue'
// import UploadProgress from '../../common/UploadProgress.vue'
import axios from 'axios'
import UploadBox from '../../common/form/formModules/UploadBox.vue'

let controller = new AbortController()

export default {
  name: 'AddPost',
  components: { PageHeader, BaseText, EditorInput, Toast, Loader, Section, Tags, TextAreaInput, VideoUpload, DateTimeOffset, UploadBox },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imageCrop: { width: 400, height: 200 },
      uploadedVideo: '',
      preview: false,
      model: {
        title: '',
        writer: '',
        timeToRead: undefined,
        description: '',
        subject: [],
        date: '',
        url: '',
        urlName: '',
        urlType: '',
        secondUrl: '',
        secondUrlName: '',
        secondUrlType: '',
        shortDescription: '',
        link: '',
        image: '',
        isEnable: false,
        template: undefined,
        isSuperior: false,
        seoKeyword: [],
        seoDescription: '',
        seoUrlDescription: '',
        imageAlternateText: '',
      },
      url: [],
      submit: false,
      percentCompleted: 0,
      checkFile: '',
      videoLoading: false,
      articleCategories: [
        { value: 'پادکست', key: '0' },
        { value: 'رادیویی', key: '1' },
        { value: 'اخبار', key: '2' },
        { value: 'مقالات', key: '3' },
        { value: 'لایو', key: '4' },
        { value: 'جزوات آموزشی', key: '5' },
        { value: 'لینک های کاربردی', key: '6' },
        { value: 'فرم ها/صورت جلسات', key: '7' },
        { value: 'نمونه قراردادها', key: '8' },
        { value: 'آرای قضایی', key: '9' },
        { value: 'آرای داوری', key: '10' },
      ],
      message: '',
      cropperLoading: false,
      error: false,
      showToast: false,
      loading: false,

      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت مقالات', active: true },
      ],
    }
  },
  watch: {
    showToast(c) {
      this.$nextTick(() => {
        if (c) this.showToast = false
      })
    },
  },
  async mounted() {
    // await this.fetchArticleCategories()

    if (this.update) {
      this.fetchPost()
    }
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadImage(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    onOpenVideoModal() {
      if (this.model.url && this.model.url.length) return
      else this.$bvModal.show('videoModal')
    },
    setDate(event) {
      if (event) {
        this.model.date = event.split('/').join('-')
      }
    },
    uploadedFile($event) {
      this.model.secondUrl = $event[0]?.url
      this.model.secondUrlName = $event[0]?.name
      this.model.secondUrlType = $event[0]?.name.split('.')[$event[0].name.split('.').length - 1]
      if ($event[0] && $event[0].name.length) {
        this.checkFile = $event[0].name.split('.')[$event[0].name.split('.').length - 1]
      }
    },
    onChooseTemplate(template) {
      this.model.template = Number(template)
    },
    onUploadFile(file) {
      this.checkFile = file.target.files[0].type.includes('audio') ? 'audio' : 'video'
      this.model.urlName = file.target.files[0].name
      this.model.urlType = file.target.files[0].name.split('.').slice(-1)[0]
    },

    async uploadVideo(e) {
      try {
        this.cropperLoading = true
        this.videoLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })
        this.videoLoading = false

        this.model.url = req.data.data[0].downloadUrl
        setTimeout(() => {
          this.percentCompleted = 0
          this.$bvModal.hide('videoModal')
        }, 2000)
      } catch (error) {
        this.cropperLoading = false
      }
      this.cropperLoading = false
    },
    closeUpload() {
      this.$bvModal.hide('videoModal')
      controller.abort()
      this.videoLoading = false
      controller = new AbortController()
      this.percentCompleted = 0

      this.model.url = ''
      this.model.urlName = ''
      this.model.urlType = ''
    },
    async addPost() {
      console.log(this.model.link)

      this.submit = true
      if (!this.model.image || !this.model.title.length || this.model.template === undefined) {
        this.error = true
        this.showToast = true
        this.message = `لطفا ${this.model.template === undefined ? 'قالب مورد نظر پست را انتخاب نمایید.' : 'فیلد موارد الزامی تکمیل گردند.'} `
        return
      }

      this.loading = true
      try {
        if (this.update) {
          const req = await dadbanArticlesProvider.updatePost({
            ...this.model,
            template: Number(this.model.template),
            isEnable: !this.model.isEnable,
            link: this.model.link && this.model.link.length === 34 && this.model.link.includes('br') ? null : this.model.link,
            // date: this.model.date?.length ? this.model.date : undefined,
          })
          if (req.status === 200) {
            // this.$router.push('/list/posts' + localStorage.getItem('query'))
            this.error = false
            this.showToast = true
            this.message = 'تغییرات با موفقیت ذخیره گردید.'
          } else {
            this.error = true
            this.showToast = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }

        const req = await dadbanArticlesProvider.addPost({
          ...this.model,
          template: Number(this.model.template),
          link: this.model.link && this.model.link.length === 34 && this.model.link.includes('br') ? null : this.model.link,
          isEnable: !this.model.isEnable,
          date: this.model.date.length ? this.model.date : undefined,
        })
        if (req.status === 200) {
          // this.$router.push('/list/posts')
          this.error = false
          this.showToast = true
          this.message = 'ثبت اطلاعات با موفقیت صورت گرفت.'
          this.loading = false
          setTimeout(() => {
            this.$router.push({ path: `/list/posts/detail/${req.data.data.id}` })
          }, 1000)
        } else {
          this.error = true
          this.showToast = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    async fetchPost() {
      this.loading = true

      const req = await dadbanArticlesProvider.getPost(+this.$route.params.id)
      this.loading = false
      if (req.status !== 200) return
      this.model = req.data.data.output
      // this.model.date = this.model.date === '0001-01-01T00:00:00+00:00' ? '' : this.model.date
      this.model.isEnable = !this.model.isEnable
    },
    // async fetchArticleCategories() {
    //   this.loading = true
    //   try {
    //     const req = await dadbanArticlesProvider.getArticleCategory()
    //     req.data.data.output.forEach((item) => {
    //       this.articleCategories.push({ value: item.title, key: item.id })
    //     })
    //     this.loading = false
    //   } catch (error) {
    //     console.log(error)
    //     this.loading = false
    //   }
    // },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })

      this.model.image = req.data.data.downloadUrl
      this.cropperLoading = false
    },
    async deleteArticle() {
      this.loading = true
      try {
        const req = await dadbanArticlesProvider.deletePost(+this.$route.params.id)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          this.$router.push('/list/posts' + localStorage.getItem('query'))
        } else {
          this.error = true
          this.showToast = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 1rem;
}

.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    padding: 2px !important;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload_text {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload_icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.empty_upload_icon {
  border: 2px dashed red;
}

.upload_video {
  height: 281px;
  width: 90%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 calc(100% - 90%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  background-color: white;
}

.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 20px;
}

::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

::v-deep .b-form-tags-button {
  display: none;
}

::v-deep .b-form-tags-input {
  padding: 2px !important;
}

::v-deep .label .labelStyle {
  min-width: none !important;
}

::v-deep .quillWrapper {
  width: 90%;
}

.video {
  width: 369px;
  height: 216px;
  border-radius: 8px;
  margin: 20px 20px 0 20px;
}

.audio {
  width: 369px;
  height: 200px;
  display: flex;
  justify-content: center;
  background-color: #f9f9f9;
  align-items: center;
}

.audio_border {
  border: 2px solid #ced4da;
  border-radius: 8px;
}

.icon {
  font-size: 100px;
}

.progress-b {
  margin: 15px auto;
  direction: ltr;
  width: 85%;
  position: relative;
  left: -10px;
}

.percent {
  width: 100%;
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  top: -28px;
  right: -10px;
}

.close_icon {
  position: absolute;
  top: 35px;
  left: 30px;
  font-size: 20px;
  color: grey;
  cursor: pointer;
}

::v-deep .image-class {
  width: 350px;
}

::v-deep .image_container {
  width: 350px;
}

.template_error {
  color: rgb(254, 94, 97);
  margin: 10px 0;
}

.pro {
  width: 210px;
}

::v-deep .time_to_read .labelStyle {
  white-space: normal !important;
}
</style>
